export const COMPANY_TYPES = {
  SUPPLIER: 'supplier',
  CUSTOMER: 'customer',
}

export const COMPANY_TYPE_DISPLAY_NAMES = {
  [COMPANY_TYPES.SUPPLIER]: 'Supplier',
  [COMPANY_TYPES.CUSTOMER]: 'Customer',
}
